import {Link as ReactRouterLink} from "react-router-dom";
import React from "react";

export const Link = ({children, to}: { children: any, to: string }) => {
    return (
        <ReactRouterLink to={to} style={{color: "inherit", textDecoration: "inherit"}}>
            {children}
        </ReactRouterLink>
    );
}